module.exports = __webpack_public_path__ + "img/deer-8157052_1280_thumb.e1906ab4.png";